import { useMemo } from 'react';
import { formatDate, formatDateForInput } from '../../../../utils/dateUtils';
import { AuditStatus } from '../../../../utils/enums';

export const useAuditMilestones = (audit) => {
  return useMemo(() => {
    if (!audit) return [];

    const today = new Date();
    const isAuditClosed = audit.audit_status === AuditStatus.COMPLETED || audit.audit_status === AuditStatus.ARCHIVED;

    const createMilestone = ({
      id,
      title,
      date,
      completedDescription,
      pendingDescription,
      defaultOrder,
      checkFuture = false,
      isCompletedOverride = undefined,
      skippedDescription = null,
    }) => {
      const dateKey = formatDateForInput(date);
      const dateObj = dateKey ? new Date(`${dateKey}T00:00:00`) : null;
      const isCompleted = typeof isCompletedOverride === 'boolean'
        ? isCompletedOverride
        : (checkFuture ? (dateObj && dateObj <= today) : Boolean(dateObj));
      const isSkipped = isAuditClosed && !isCompleted && id !== 'audit_close';

      return {
        id,
        title,
        date,
        dateObj,
        description: isSkipped
          ? (skippedDescription || pendingDescription)
          : (isCompleted ? completedDescription : pendingDescription),
        icon: isSkipped ? 'dash' : (isCompleted ? 'check' : 'number'),
        isCompleted,
        isSkipped,
        defaultOrder,
      };
    };

    const milestones = [
      createMilestone({
        id: 'audit_plan',
        title: 'Audit Plan Created',
        date: audit.rego_valid_from,
        completedDescription: `Audit plan created on ${formatDate(audit.rego_valid_from)}`,
        pendingDescription: 'Audit plan not yet created',
        defaultOrder: 1,
        checkFuture: true,
      }),
      createMilestone({
        id: 'audit_start',
        title: 'Audit Period Starts',
        date: audit.audit_start_date,
        completedDescription: `Audit Period Started on ${formatDate(audit.audit_start_date)}`,
        pendingDescription: `Audit Period Starts on ${formatDate(audit.audit_start_date)}`,
        defaultOrder: 2,
        checkFuture: true,
      }),
      createMilestone({
        id: 'audit_end',
        title: 'Audit Period Ends',
        date: audit.audit_end_date,
        completedDescription: `Audit Period Ended on ${formatDate(audit.audit_end_date)}`,
        pendingDescription: `Audit Period Ends on ${formatDate(audit.audit_end_date)}`,
        defaultOrder: 3,
        checkFuture: true,
      }),
      createMilestone({
        id: 'audit_close',
        title: audit.audit_status === AuditStatus.ARCHIVED ? 'Audit Archived' : 'Audit Successfully Completed',
        date: isAuditClosed ? (audit.rego_valid_till || audit.audit_end_date) : null,
        completedDescription: audit.audit_status === AuditStatus.ARCHIVED ? 'Audit has been archived' : 'Audit ended by auditor',
        pendingDescription: 'Audit not ended by auditor',
        defaultOrder: 4,
        isCompletedOverride: isAuditClosed,
      }),
    ];

    return milestones;
  }, [audit]);
};